import { useState } from "preact/hooks";
import type { PageContent } from "../content/index.js";

export interface FaqProps {
  readonly content: PageContent;
}

export function Faq({ content }: FaqProps) {
  const [open, setOpen] = useState<number | null>(null);
  return (
    <section class="section faq" id="faq">
      <div class="wrap">
        <p class="micro">{content.faq.label}</p>
        <h2 class="section-title serif">{content.faq.title}</h2>
        <div class="faq-list">
          {content.faq.items.map(([question, answer], index) => (
            <div key={question} class="faq-item">
              <button
                type="button"
                class="faq-question"
                aria-expanded={open === index}
                aria-controls={`faq-answer-${index}`}
                onClick={() => setOpen(open === index ? null : index)}
              >
                <span>{question}</span>
                <span class="faq-sign" aria-hidden="true">
                  {open === index ? "−" : "+"}
                </span>
              </button>
              <p class="faq-answer" id={`faq-answer-${index}`} hidden={open !== index}>
                {answer}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
